import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { faqItems } from './data';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="relative w-full bg-ink-950 py-12 sm:py-16" data-id="element-41">
      <div className="mx-auto max-w-3xl px-5" data-id="element-42">
        <SectionHeading eyebrow="Manejo de objeciones" data-id="element-43">FAQ</SectionHeading>
        <Reveal delay={0.05} data-id="element-44">
          <p className="mt-3 text-center text-sm text-silver/60 sm:text-base" data-id="element-45">
            <span className="font-semibold text-silver/80" data-id="element-46">F</span>requently{' '}
            <span className="font-semibold text-silver/80" data-id="element-47">A</span>sked{' '}
            <span className="font-semibold text-silver/80" data-id="element-48">Q</span>uestions —{' '}
            <span className="text-accent-light" data-id="element-49">Preguntas Frecuentes</span>
          </p>
        </Reveal>

        <div className="mt-10 space-y-3" data-id="element-50">
          {faqItems.map((item, i) => {
          const isOpen = open === i;
          return <Reveal key={item.question} delay={i * 0.08} data-id="element-51">
                <div className={`overflow-hidden rounded-2xl border bg-ink-800/50 transition-colors ${isOpen ? 'border-accent/40' : 'border-white/8'}`} data-id="element-52">
                  <h3 data-id="element-53">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-54">
                      <span className="text-sm font-semibold text-white sm:text-base" data-id="element-55">
                        {item.question}
                      </span>
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? 'bg-accent text-ink-950' : 'bg-ink-700 text-accent'}`} data-id="element-56">
                        {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" />}
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-59">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-60">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-silver/75" data-id="element-61">
                          {item.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}